import { PageType } from 'api/page-template/types';
import { useCallback } from 'react';
import { useDisablePageMutation } from '.';

type UseDeletePageParams = {
  pageDocumentMappingId?: number;
  documentId?: number;
  pageType?: PageType;
  companyId: number;
  /** Flat list of all pages (excluding the deleted one will be done internally). */
  allPages: { documentId: number }[];
  navigateToPage: (companyId: number, documentId: number) => void;
  navigateToList: (companyId: number) => void;
};

export const useDeletePage = ({
  pageDocumentMappingId,
  documentId,
  pageType,
  companyId,
  allPages,
  navigateToPage,
  navigateToList,
}: UseDeletePageParams) => {
  const { mutate: disablePage } = useDisablePageMutation();

  const handleDelete = useCallback(() => {
    if (!pageDocumentMappingId || !documentId || !pageType) {
      return;
    }

    disablePage(
      {
        pageDocumentMappingId,
        pageType,
        documentId,
      },
      {
        onSuccess: () => {
          const remainingPages = allPages.filter(
            (page) => page.documentId !== documentId,
          );

          if (remainingPages.length > 0) {
            navigateToPage(companyId, remainingPages[0].documentId);
          } else {
            navigateToList(companyId);
          }
        },
      },
    );
  }, [
    pageDocumentMappingId,
    documentId,
    pageType,
    disablePage,
    allPages,
    companyId,
    navigateToPage,
    navigateToList,
  ]);

  return { handleDelete };
};
